import { useLocation } from 'react-router-dom';
import { useHasPermissions } from 'utils/permissionUtil';

export type GlobalAddItem = {
    label: string;
    url: string;
};

const CREATE_TIMECARDS = ['CREATE.TIMECARDS'];
const CREATE_PARTIES = ['CREATE.PARTIES', 'CREATE.PARTIES.CLIENTS', 'CREATE.PARTIES.LEADS_AND_NON_CLIENTS'];
const CREATE_MATTERS = ['CREATE.MATTERS', 'CREATE.MATTERS.CLIENTS'];
const CREATE_CONTRACTS = ['CREATE.CONTRACTS'];
const CREATE_EFFORTS = ['CREATE.EFFORTS'];
const CREATE_TASKS = ['CREATE.TASKS'];
const CREATE_COI_CHECKS = ['CREATE.COI_CHECKS'];

/**
 * The create pages the app-wide add menus offer — the floating + and the new design's New — each
 * behind the permission it needs. Empty on a create or edit page, where neither menu shows.
 */
export function useGlobalAddItems(): GlobalAddItem[] {
    const { pathname } = useLocation();

    const canCreateTimecards = useHasPermissions(CREATE_TIMECARDS);
    const canCreateParties = useHasPermissions(CREATE_PARTIES);
    const canCreateMatters = useHasPermissions(CREATE_MATTERS);
    const canCreateContracts = useHasPermissions(CREATE_CONTRACTS);
    const canCreateEfforts = useHasPermissions(CREATE_EFFORTS);
    const canCreateTasks = useHasPermissions(CREATE_TASKS);
    const canCreateCoiChecks = useHasPermissions(CREATE_COI_CHECKS);

    if (/(\/(?:edit|new))$/.test(pathname)) {
        return [];
    }

    const items: (GlobalAddItem & { allowed: boolean })[] = [
        { label: 'Timecard', url: '/timecards/new', allowed: canCreateTimecards },
        { label: 'Contact', url: '/contact/new', allowed: canCreateParties },
        { label: 'Case', url: '/matter/new', allowed: canCreateMatters },
        { label: 'Contract', url: '/contract/new', allowed: canCreateContracts },
        { label: 'BD effort', url: '/effort/new', allowed: canCreateEfforts },
        { label: 'Task', url: '/task/new', allowed: canCreateTasks },
        { label: 'COI check', url: '/coi-checks', allowed: canCreateCoiChecks },
    ];
    return items.filter((item) => item.allowed).map(({ label, url }) => ({ label, url }));
}
